import { Grid } from '@design-systems/canvas-ui'
import { BasicPlaceholder } from 'components/placeholder'
import { TRANSLATION_KEYS } from 'locales/translation-keys'
import { useEssentials } from 'hooks/utils/useEssentials'
import { Cell, getNegativeStyle } from 'utils/data'
import { formatNegative } from 'utils/number-format'

interface IGridData {
    isLoading: boolean
    data: Cell[]
    isNextMonth?: boolean
}

export const GridData = ({
    isLoading,
    data,
    isNextMonth = false,
}: IGridData) => {
    const { t } = useEssentials()
    const { payroll } = TRANSLATION_KEYS
    const { location } = payroll

    if (isLoading) {
        return (
            <div
                className="placeholder-container"
                data-testid="placeholder-grid"
            >
                <BasicPlaceholder type="text" rows={3} />
            </div>
        )
    }

    const [projectedFlexHoursVal, trailerFlexHoursVal, adjustmentsVal] = data
    return (
        <>
            {!isNextMonth && (
                <Grid.Item
                    className="grid-item hc8-pv-3x"
                    size={{
                        xs: 12,
                    }}
                >
                    <p className="hc8-fs-050 hc8-ma-none">
                        {t(location.projFlexHours)}
                    </p>
                    <p
                        className={getNegativeStyle(
                            projectedFlexHoursVal?.value,
                        )}
                    >
                        {formatNegative(projectedFlexHoursVal?.value)}
                    </p>
                </Grid.Item>
            )}
            {!isNextMonth && (
                <Grid.Item
                    className="grid-item hc8-pb-3x"
                    size={{
                        xs: 12,
                    }}
                >
                    <p className="hc8-fs-050 hc8-ma-none">
                        {t(location.trailerFlexHours)}
                    </p>
                    <p className={getNegativeStyle(trailerFlexHoursVal?.value)}>
                        {formatNegative(trailerFlexHoursVal?.value)}
                    </p>
                </Grid.Item>
            )}
            <Grid.Item
                className="grid-item hc8-pb-6x"
                size={{
                    xs: 12,
                }}
            >
                <p className="hc8-fs-050 hc8-ma-none">
                    {t(location.adjustments)}
                </p>
                <p className={getNegativeStyle(adjustmentsVal?.value)}>
                    {formatNegative(adjustmentsVal?.value)}
                </p>
            </Grid.Item>
        </>
    )
}
